import { useMemo } from 'react';
import { TZDate } from '@date-fns/tz';
import { format as formatDate, parse, parseISO } from 'date-fns';

import { useOfficeCtx } from '@/components/providers/v1-office-provider';
import { formatDateTimeInUTC } from '@/lib/format';

interface Props {
  value: string | Date;
  format: string;
}

export function DateTime({ value, format }: Props) {
  const { office } = useOfficeCtx();
  const str = useMemo(() => {
    const date = typeof value === 'string' ? parseISO(value) : value;
    if (office.timezone) {
      const tzDate = new TZDate(date.getTime(), office.timezone);
      return formatDate(tzDate, format);
    }
    return formatDate(date, format);
  }, [value, office.timezone, format]);

  return <>{str}</>;
}

export function DateTimeInUTC({ value, format }: Props) {
  const str = useMemo(() => formatDateTimeInUTC(value, format), [value, format]);

  return <>{str}</>;
}

interface TimeProps {
  value: string;
  format: string;
}

/* Formats a time string (e.g. "10:00:00") to a provided format. */
export function TimeInUTC({ value, format }: TimeProps) {
  const str = useMemo(() => {
    const inFmt = value.split(':').length === 2 ? 'HH:mm' : 'HH:mm:ss';
    const d = parse(value, inFmt, new Date());
    return formatDate(d, format);
  }, [value, format]);

  return <>{str}</>;
}
